import { render, staticRenderFns } from "./NewUserUpload.vue?vue&type=template&id=81944300&"
import script from "./NewUserUpload.vue?vue&type=script&lang=js&"
export * from "./NewUserUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports